// src/components/PhoneNumberCard.js
import { Card, CardActions, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material";
import PhoneNumberField from "./PhoneNumberField"; // Import the PhoneNumberField component
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";

export default function PhoneNumberCard({ settings, handleChange, onConfirm, loading, error, isSuccess }) {
  const { t } = useTranslation();

  const onConfirmHandler = () => {
    onConfirm({ whatsapp: settings?.whatsapp });
  };

  return (
    <Card sx={{ mt: 3 }}>
      <CardHeader title={t("WhatsApp Number")} />
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item md={6} sm={6} xs={12}>
            <PhoneNumberField settings={settings} handleChange={handleChange} />
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse' }}>
        <LoadingButton
          sx={{ textTransform: "none" }}
          variant="contained"
          loading={loading}
          onClick={onConfirmHandler}
        >
          {t("Confirm")}
        </LoadingButton>
        {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
        {!!error && <Typography color="error">{t(error)}</Typography>}
      </CardActions>
    </Card>
  );
}
